import React, { useEffect } from "react";
import Footer from "../../Components/Common/Footer";
import Header from "../../Components/Common/Header";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import Login from "../../Components/Login/Login";

function Terms({ isLogin, Open }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="container">
      <InnerHeader isLogin={isLogin} />
      <div className="ContactUsContainer">
        <span>
          *کنتور یک اپلیکیشن کاربردی است که توسط شرکت گنجینه زرین سپهر و در
          راستای ارتقای خدمات عمومی تهیه و ارائه شده است.
        </span>
        <span>
          *برای ایجاد کاربری در کنتور بایستی شماره تلفن همراه خود را معرفی کنید
          ، این شماره تلفن، عضویت اصلی شما خواهد بود و پس از دریافت کد ارسالی از
          سامانه ، واردکنتور شوید و این کدهای ارسالی رادر اختیار هیچ شخص دیگری
          قرار ندهید.
        </span>
        <span>
          * استعلام قبوض شما توسط کنتور و از منبع تامین کننده طرف قرارداد شرکت
          های خدماتی است و کنتور هیچگونه دخل و تصرفی در این موضوع ندارد و مبالغ
          اعلامی در استعلام دقیقا" همان مبالغ ارسالی از سمت شرکت های خدماتی است
          و مدیریت به روز رسانی استعلام ها در سیستم های نرم افزاری برعهده شرکت
          های خدماتی است و کنتور دسترسی و مسئولیتی بابت این موضوع ندارد.
        </span>
        <span>
          *کلیه قبوض را با پرداخت از طریق کلیه کارت های بانکی و درگاه پرداخت
          معتبربه صورت مستقیم به شرکت های خدماتی پرداخت میکنید.
        </span>
        <span>
          *کلیه خدمات کنتور به کاربران بصورت کاملا" رایگان است و کنتور بابت
          خدمات ارائه شده به کاربران هیچگونه هزینه ای دریافت نمیکند.
        </span>
        <span>
          *در صورت پرداخت تکراری یک قبض توسط کاربر به شرکت های خدماتی ، مسئولیتی
          متوجه کنتور نخواهد بود.
        </span>
        <span>
          *با توجه به شرایط جدید ممکن است مقررات دیگری اضافه شود لذا خواهشمند
          است بصورت دوره ای این مقررات را مطالعه بفرمائید.
        </span>
        <span>
          *با ورود به کنتور و استفاده از این اپلیکیشن کلیه مقررات فوق را
          میپذیرم.
        </span>
      </div>
      <Footer isLogin={isLogin} />
      {Open && <Login />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(Terms);
